<template>
  <div class="container">
    <b-form>
      <b-form-group id="title" label="标题:" label-for="title">
        <b-form-input id="title" v-model="formData.title" type="text" required placeholder="输入文章标题"></b-form-input>
      </b-form-group>

      <b-form-group label="文章类型">
        <b-form-radio-group v-model="formData.tag" :options="options"></b-form-radio-group>
      </b-form-group>

      <b-form-group id="source" label="封面图片链接:" label-for="source">
        <b-form-input id="source" v-model="formData.cover" type="url" required placeholder="输入 URL"></b-form-input>
      </b-form-group>

      <b-form-group id="abstract" label="概述:" label-for="abstruct">
        <b-form-textarea
          id="abstruct"
          v-model="formData.abstract"
          placeholder="输入文章摘要..."
          rows="5"
          max-rows="10"
        ></b-form-textarea>
      </b-form-group>

      <b-button-group class="m-3">
        <b-button
          v-if="!submitted"
          type="submit"
          variant="primary"
          @click.prevent="submitFormData"
        >发布</b-button>
        <b-button v-if="!submitted" type="submit" variant="danger" @click.prevent="resetFormData">重置</b-button>
        <b-spinner label="Spinning" v-else></b-spinner>
      </b-button-group>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      mode: "add",
      submitted: false,
      options: [
        { text: "书籍", value: "book" },
        { text: "影视", value: "film" },
        { text: "唱片", value: "album" }
      ],
      formData: {
        title: "",
        abstract: "",
        cover: "",
        tag: ""
      },
      temp: {
        title: "",
        abstract: "",
        cover: "",
        tag: ""
      }
    };
  },
  computed: {
    ...mapState(["account", "articles", "changeArticle"]),
    ...mapGetters(["filterById"])
  },
  watch: {
    filterById: function() {
      this.formData.title = this.filterById.title;
      this.formData.abstract = this.filterById.abstract;
      this.formData.tag = this.filterById.tag;
      this.formData.cover = this.filterById.cover;
      this.temp.title = this.filterById.title;
      this.temp.abstract = this.filterById.abstract;
      this.temp.tag = this.filterById.tag;
      this.temp.cover = this.filterById.cover;
    }
  },
  methods: {
    ...mapActions(["updateArticle"]),
    resetFormData() {
      if (this.mode === "edit") {
        this.formData.title = this.temp.title;
        this.formData.abstract = this.temp.abstract;
        this.formData.tag = this.temp.tag;
        this.formData.cover = this.temp.cover;
      } else {
        this.formData = {
          title: "",
          abstract: "",
          cover: "",
          tag: ""
        };
      }
    },
    submitFormData() {
      this.submitted = true;
      this.formData.date = new Date().getTime();
      if (this.mode === "edit") {
        this.$store
          .dispatch("updateArticle", {
            id: this.$route.params.id,
            newArticle: this.formData
          })
          .then(() => {
            this.$router.push({ name: "AdminHome" });
          });
      } else {
        this.$store.dispatch("addArticle", this.formData).then(() => {
          this.$router.push({ name: "AdminHome" });
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.submitted) {
      this.$bvModal
        .msgBoxConfirm("当前更改未保存，离开当前页面可能造成数据丢失", {
          title: "是否离开当前页面",
          okVariant: "danger",
          okTitle: "离开",
          cancelTitle: "取消",
          centered: true
        })
        .then(value => {
          if (value) {
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$route.name === "AdminEdit") {
        let id = vm.$route.params.id;
        vm.$store.dispatch("changeFocusId", id);
        vm.mode = "edit";
      } else if (vm.$route.name === "AdminAdd") {
        vm.mode = "add";
        vm.resetFormData();
      }
    });
  }
};
</script>